<template>
<div id="contents">
  <div id="players" class="page_contents">

    <div id="players_contents">
      <div id="players_show" v-if="player">

        <div id="players_show_main" class="page_main_contents" v-bind:class="{ ceo_main: new_ceo }">
          <p id="players_show_main_image" v-bind:style="{ backgroundImage: 'url(' + player.kv_image + ')' }" v-if="!new_ceo"></p>
          <div v-if="!new_ceo" id="players_show_main_name">
            <p class="job">{{player.job_type}}</p>
            <h1>{{player.title}}</h1>
            <p class="name_en">{{player.staff_name_en}}</p>
          </div><!-- #players_show_main_name -->
          <p v-if="!new_ceo" id="players_show_main_num" v-bind:data="this.player.staff_number"></p>

          <p v-if="ceo && !new_ceo" id="top_message_title"><img src="../assets/img/players/top_message.png" width="241" alt="TOP MESSAGE" ></p>
          <p v-if="new_ceo" id="top_message_new_title"><img src="../assets/img/players/top_message_large.png" width="528" alt="TOP MESSAGE" ></p>

          <div v-if="new_ceo" id="top_message_kv">
            <h3 id="top_message_kv_copy">いいものを創り続けるということ</h3>
            <p id="ceo_image"><img src="../assets/img/players/wakabayashi.png" width="860" alt="若林 邦彦" ></p>
          </div>

          <p class="page_close hover" v-bind:class="{ ceo_page_close: new_ceo }" v-if="referrer == 'company_index' "><router-link v-bind:to="{name: 'company_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>

          <p class="page_close hover" v-bind:class="{ ceo_page_close: new_ceo }" v-else><router-link v-bind:to="{name: 'players_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #players_show_main -->

        <div id="players_show_job_list" v-if="this.player.job_list && !ceo">
          <p v-html="works_list"></p>
        </div><!-- #players_show_job_list -->

        <div id="players_show_body" class="page_main_contents">

          <p id="top_message_copy" v-if="ceo && !new_ceo">「トップクリエイター集団」を作るという挑戦。</p>

          <div id="mynavi_interview_pdf" v-if="this.$route.params.id == 8830">
            <p>「マイナビ　就活準備　完全ガイド」掲載のインタビュー<a href="http://jobebook.mynavi.jp/library/21/start/html5.html#page=189" target="_blank">⇒こちら</a></p>
          </div>

          <div class="palyers_show_quetion" v-bind:class="{ ceo_message: new_ceo }">
            <h2 v-if="ceo && !new_ceo">会社としての強み、大切にしていること</h2>
            <h2 v-if="!ceo">仕事とやり甲斐</h2>

            <div class="answer">
              <p>{{player.job_content}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->

          <div v-if="!new_ceo" class="palyers_show_quetion">
            <h2 v-if="ceo">今後の展望、どんな未来を形にしていくか</h2>
            <h2 v-else>ヒットコンテンツをつくるために心がけていること</h2>
            <div class="answer">
              <p>{{player.hit_contents}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->

          <div v-if="!new_ceo" class="palyers_show_quetion">
            <h2 v-if="ceo">社長としてチャレンジしたいこと</h2>
            <h2 v-else>目指しているPLAYer像</h2>
            <div class="answer">
              <p>{{player.aim_at}}</p>
            </div><!-- .answer -->
          </div><!-- .palyers_show_quetion -->


          <div v-if="!ceo" id="players_show_staff_column">
            <h3>最近のPLAYな出来事</h3>
            <div id="players_show_staff_column_inner">
              <p v-bind:class="{ text_only: player.event_image }">{{player.event_text}}</p>
              <p><img :src="player.event_image" width="327" /></p>
            </div><!-- #palyers_show_staff_column_inner -->
          </div><!-- #palyers_show_staff_column -->

          <div v-if="new_ceo" id="ceo_name">
            <p>テレビ朝日映像株式会社</p>
            <p>代表取締役社長 兼 エグゼクティブプロデューサー</p>
            <p><img src="../assets/img/players/wakabayashi_name.png" width="176" /></p>
          </div>

          <div id="players_show_profile" v-bind:class="{ ceo_profile: new_ceo }">
            <h2>プロフィール</h2>
            <p>{{player.profile}}</p>
            <div class="awards" v-if="player.awards">
              <dt>受賞歴：</dt>
              <dd v-html="player.awards"></dd>
            </div><!-- .awards -->
          </div><!-- #palyers_show_profile -->

          <div id="players_show_program" v-if="player.program_list && !ceo">
            <h2>担当番組</h2>
            <ul>
              <li v-for="program in player.program_list" :key="program.post_id">
                <router-link v-bind:to="{ name : 'works_program_show', params : { id: program.post_id }}" class="hover"><img :src="program.img_path" width="306" /></router-link>
              </li>
            </ul>
          </div><!-- #players_show_program -->

        </div><!-- #palyers_show_body -->

        <div id="players_show_other_palyer" v-if="!ceo">
          <h3><img src="../assets/img/players/other_player_title.png" width="332" alt="OTHER PLAYers" /></h3>
          <div id="players_show_other_palyer_inner">

            <div v-for="other_player in player.other_player_list" :key="other_player.post_id" class="player_card hover">
              <p class="other_player_image"><router-link v-bind:to="{name: 'players_show', params: {id: other_player.post_id}}"><img :src="other_player.img_path" width="100%" alt="社員の写真" /></router-link></p>
              <div class="player_card_inner">
                <h3>
                  <router-link v-bind:to="{name: 'players_show', params: {id: other_player.post_id}}">
                    <span>{{other_player.name}}</span>
                    <span>{{other_player.staff_name_en}}</span>
                  </router-link>
                </h3>
                <p class="player_num js-player_num" v-bind:data="other_player.staff_number"></p><!-- .player_num -->
              </div><!-- .player_card_inner -->
            </div><!-- .player_card -->

          </div><!-- #palyers_show_other_palyer_inner -->
        </div><!-- #palyers_show_other_palyer -->
      </div><!-- #players_show -->
    </div><!-- #players_contents -->

    <ul id="page_nav" v-if="player && !ceo">

      <p class="hover" v-if="player.next_post_id && player.next_post_id != '8010' && player.next_post_id != '9784'"><router-link v-bind:to="{name: 'players_show', params: {id: player.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
      <p v-else></p>

      <p class="hover" v-if="player.prev_post_id"><router-link v-bind:to="{name: 'players_show', params: {id: player.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
      <p v-else></p>

    </ul><!-- #page_nav -->

  </div><!-- #players -->

</div><!-- #contents -->
</template>

<script>
export default {
  name: 'players_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/players/show.php',
      loading: true,
      player: null,
      referrer: this.$attrs.referrer,
      number_image_src: [
        require("../assets/img/common/n_0.png"),
        require("../assets/img/common/n_1.png"),
        require("../assets/img/common/n_2.png"),
        require("../assets/img/common/n_3.png"),
        require("../assets/img/common/n_4.png"),
        require("../assets/img/common/n_5.png"),
        require("../assets/img/common/n_6.png"),
        require("../assets/img/common/n_7.png"),
        require("../assets/img/common/n_8.png"),
        require("../assets/img/common/n_9.png")
      ],
      error: null
    }
  },
  methods: {
    fetch_player(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.player = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_player()
    }
  },
  computed: {
    works_list: function(){
      return this.player.job_list.replace(/\n/g, '<br/>');
    },
    ceo: function () {
      if(this.player.staff_number == '1'){
        return true
      }else{
        return false
      }
    },
    new_ceo: function () {
      if(this.$route.params.id == '9784'){
        return true
      }else{
        return false
      }
    }
  },
  mounted () {

    var queue = new createjs.LoadQueue(true);
    var manifest = this.number_image_src;
    var fetch_player = this.fetch_player
    queue.loadManifest(manifest,true);
    queue.addEventListener("complete",function(){
      fetch_player()
    });
  },
  updated (){
    //画像の置き換え_main
    var number_image_list = this.number_image_src
    replaceNumber($("#players_show_main_num"))
    $('.js-player_num').each(function(){
      replaceNumber($(this))
    });
    function replaceNumber($dom){
      $dom.html('');
      var staff_num = $dom.attr('data');
      staff_num = ('0000000000' + staff_num).slice(-3);
      $dom.append('<img src="'+number_image_list[staff_num.charAt(0)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(1)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(2)]+'">');
    }//replaceNumber

    this.$emit('page_fade')
  }
}
</script>

<style scoped lang="sass">
  #players_show_main_image
    position: relative
    width: 600px
    height: 337px
    overflow: hidden
    margin: 0 auto
    img
      position: absolute
      bottom: 0
      left: 0
  #players #players_show_program ul
    align-item: center
  #players_show_other_palyer .other_player_image
    position: relative
    width: 367px
    height: 190px
    overflow: hidden
    margin: 0 auto
    img
      position: absolute
      bottom: 0
      left: 0
</style>



// WEBPACK FOOTER //
// src/components/players_show.vue